/**
 * ehr#665 / ehr#659 - small pure pieces of the session gate (auth/session.tsx, App.tsx).
 */

/**
 * ehr#665: what the page body shows for the session state. Coming back to the EHR from Messages or
 * the Schedule (other modules, so a full page load) the session is checked again, and the body
 * showed the signed-out card ("Sign in", "Checking session…") for a signed-in person until
 * /auth/me answered. While the check runs, and no one is known yet, the body is a neutral loading
 * state; the Sign in card is only for a check that came back signed out.
 */
export type SessionView = 'app' | 'checking' | 'signin';
export function sessionView(s: { signedIn: boolean; loading: boolean }): SessionView {
  if (s.signedIn) return 'app'; // a re-check (View as) keeps the page on screen
  return s.loading ? 'checking' : 'signin';
}

/**
 * ehr#659: a localStorage change made in ANOTHER EHR tab that switches who the EHR shows (View as,
 * or the local dev user picker): the key and its new value (null = stopped), else null. Every tab
 * then shows the same person, so their task totals agree.
 */
export function followSwitch(
  key: string | null,
  newValue: string | null,
): { key: 'impersonate' | 'devUser'; value: string | null } | null {
  if (key === 'impersonate' || key === 'devUser') return { key, value: newValue || null };
  return null;
}
